import { Component ,OnInit,OnDestroy, ChangeDetectorRef, Input} from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  @Input() isshow = false;

  show = false;


  public sub!: Subscription ;
  constructor(public loaderService: LoaderService, public cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.sub = this.loaderService.loaderState.subscribe((state) => {
      this.show = state;
      this.cdRef.detectChanges();
    
    })
  }
  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}

